var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"w-100"},[_c('b-card-body',{staticClass:"m-0 p-0"},[_c('json-editor',{staticClass:"h-100",attrs:{"content":JSON.stringify(_vm.value, null, 2) || '{}'},on:{"change":_vm.onChange}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }